export const AdminBGColor = 'rgba(255, 166, 166, 0.42)';
export const AdminColor = '#D12800';

export const RootBGColor = 'rgba(255, 0, 229, 0.15)';
export const RootColor = '#DB00FF';

export const ManagerBGColor = 'rgba(96, 27, 209, 0.13)';
export const ManagerColor = '#75009E';

export const ViewBGColor = 'rgba(176, 190, 197, 0.23)';
export const ViewColor = '#707070';

export const GovBGColor = 'rgba(185, 226, 244, 0.56)';
export const GovColor = '#16B1FF';

export const DevBGColor = 'rgba(254, 241, 173, 0.55)';
export const DevColor = '#FFA070';

export const CertBGColor = 'rgba(128, 255, 0, 0.12)';
export const CertColor = '#519E4F';

export const TooltipColor = '#6ACDFF';

export const InvestmentBGColor = 'rgba(151, 110, 215, 0.3)';
export const InvestmentColor = '#9155fd';
